import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const CenteredBox = styled(Box)`
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: center;
`;

export default CenteredBox;
